<template lang="pug">
  lazy-load(
    v-bind="$attrs"
    v-on="$listeners"
  )
    .course-management-list
      v-alert(
        v-if="!courses.length"
        type="info"
        text
        prominent
        color="secondary"
      ).ma-4
        v-row(align="center")
          v-col.grow Ни один курс не создан...
          v-col.shrink
            v-btn(
              outlined
              rounded
              color="secondary"
              :to=`{
                name: 'CourseCreate',
              }`
            ) Перейти к созданию
      v-card(
        v-for="course in courses"
        :key="course.id"
      ).sdo-card.sdo-card--hover.pa-2.fill-height.mb-5
        v-img(
          v-if="!hideImage"
          :src="course.image ? course.image.url : require('@/assets/course-sample.png')"
          alt="Изображение курса"
          height=150
        ).sdo-card__image.text-right
          span(v-if="course.type_activity" class="sdo-card__activity px-3 py-1 ma-4")
            | {{ course.type_activity_name }}

        v-card-text
          v-list
            v-list-item
              v-list-item-content
                .title.font-weight-bold.mb-2 {{ course.title }}
                v-list-item-subtitle(
                  v-text="$conf.COURSE_TYPES_TEXT[course.type]"
                )
              v-list-item-action
                tooltip-wrap(text="Настройки нейросети")
                  v-btn(
                    :to="{ name: 'CourseGPTSettings', params: { id: course.id } }"
                    text outlined
                    fab depressed
                  )
                    v-icon mdi-robot
          v-row(no-gutters)
            v-col(cols=12 sm=6 md=3)
              v-list-item.grey.lighten-4.tile(
                :to="{ name: 'CourseUnits', params: { id: course.id }}"
              )
                v-icon.mr-2(color="grey darken-4") mdi-list-box-outline
                v-list-item-title: strong Структура
            v-col(cols=12 sm=6 md=3)
              v-list-item.grey.lighten-4.tile(
                :to="{ name: 'CourseEnrollment', params: { id: course.id } }"
              )
                v-icon.mr-2 mdi-account-multiple
                v-list-item-title: strong Наборы
            v-col(cols=12 sm=6 md=3)
              v-list-item.grey.lighten-4.tile(
                :to="{ name: 'CourseManagementConstructor', params: { id: course.id } }"
              )
                v-icon.mr-2 mdi-page-layout-body
                v-list-item-title: strong Страница курса
            v-col(cols=12 sm=6 md=3)
              v-list-item.grey.lighten-4.tile(
                :to="{ name: 'CourseSettings', params: { id: course.id } }"
              )
                v-icon.mr-2 mdi-cog
                v-list-item-title: strong  Настройки

          v-list.pb-0.mb-0
            .my-3
            v-subheader.d-flex
              .text-uppercase Активные наборы
              v-spacer
              tooltip-wrap(
                text="Добавить набор"
              )
                v-btn(
                  color="secondary"
                  depressed
                  text
                  fab
                  outlined
                  small
                  :to="{ name: 'EnrollmentCreate', params: { id: course.id } }"
                )
                  v-icon mdi-plus

            v-list-item(v-if="!course.prior_records")
              v-list-item-content
                v-list-item-subtitle Активных наборов пока еще нет...

            v-list-item(
              v-for="record in course.prior_records"
              :key="record.id"
              :to=`{
                name: 'CourseEnrollmentRecords',
                params: { enrollmentId: record.id, id: course.id }
              }`
            ).my-2
              v-list-item-avatar
                v-avatar(color="secondary lighten-1").caption.white--text {{ record.code }}
              v-list-item-content
                v-list-item-subtitle
                  | {{ record.start_learning | dp('d MMMM y') }} -
                  |  {{ record.end_learning | dp('d MMMM y') }}
                  .caption.opacity Период обучения
              v-list-item-action
                v-btn(
                  depressed
                  :to=`{
                    name: 'CourseGroupList',
                    params: { id: course.id, enrollmentId: record.id }
                  }`
                )
                  span Группы
                  v-icon(right) mdi-menu-right
</template>

<script>
export default {
  props: {
    courses: { type: Array, required: true },
    hideActions: { type: Boolean, default: false },
    hideImage: { type: Boolean, default: false },
  },
  methods: {
    async courseActivate(courseId) {
      await this.$rHandler(
        this.$api.courses.updateStatus(
          courseId, { status: this.$conf.COURSE_STATUSES.active },
        ),
        (r) => {
          this.$toasted.success('Курс запущен в реализацию!', { duration: 3000 });
          return r;
        },
        () => {
          this.$toasted.error('Не удалось запустить курс в реализацию.', { duration: 3000 });
        },
      );
    },
  },
};
</script>
<style lang="scss" scoped>
  .tile {
    border-radius: 0 !important;
  }
</style>
